var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 18.2644L10.3125 14.3686L11.5958 13.0853L14.2083 15.6978L19.3875 10.5186L20.6708 11.8019L14.2083 18.2644ZM19.25 9.1665H17.4167V4.58317H15.5833V7.33317H6.41667V4.58317H4.58333V17.4165H10.0833V19.2498H4.58333C4.07917 19.2498 3.64757 19.0703 3.28854 18.7113C2.92951 18.3523 2.75 17.9207 2.75 17.4165V4.58317C2.75 4.079 2.92951 3.64741 3.28854 3.28838C3.64757 2.92935 4.07917 2.74984 4.58333 2.74984H8.41042C8.57847 2.21512 8.90694 1.77588 9.39583 1.43213C9.88472 1.08838 10.4194 0.916504 11 0.916504C11.6111 0.916504 12.1573 1.08838 12.6385 1.43213C13.1198 1.77588 13.4444 2.21512 13.6125 2.74984H17.4167C17.9208 2.74984 18.3524 2.92935 18.7115 3.28838C19.0705 3.64741 19.25 4.079 19.25 4.58317V9.1665ZM11 4.58317C11.2597 4.58317 11.4774 4.49532 11.6531 4.31963C11.8288 4.14393 11.9167 3.92623 11.9167 3.6665C11.9167 3.40678 11.8288 3.18907 11.6531 3.01338C11.4774 2.83768 11.2597 2.74984 11 2.74984C10.7403 2.74984 10.5226 2.83768 10.3469 3.01338C10.1712 3.18907 10.0833 3.40678 10.0833 3.6665C10.0833 3.92623 10.1712 4.14393 10.3469 4.31963C10.5226 4.49532 10.7403 4.58317 11 4.58317Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfp);
export default __webpack_public_path__ + "static/media/rfp.426c01c0abde2b8b4caa23245b36ba92.svg";
export { ForwardRef as ReactComponent };